export enum FileTypes {
  Image,
  Audio,
  Video,
  CVS,
  Document
}
